// extracted by mini-css-extract-plugin
module.exports = {"loadingMessageContainer":"HotelBlock_loadingMessageContainer__3_dpU","iconSync":"HotelBlock_iconSync__3_aFI","fa-spin":"HotelBlock_fa-spin__2FMJd"};